import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=07938252&"
import script from "./orderCenter.vue?vue&type=script&lang=js&"
export * from "./orderCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports